export const GAME_ROOT_ROUTE: string[] = ['game'];

export const GAME_LOCATION_LIST_ROUTE = [...GAME_ROOT_ROUTE, 'location-list'];
export const GAME_LOCATION_DETAIL_ROUTE = [
  ...GAME_ROOT_ROUTE,
  'location-detail',
];
export const GAME_NEW_ROUTE = [...GAME_ROOT_ROUTE, 'new'];
export const GAME_NEW_SETTINGS_ROUTE = [
  ...GAME_ROOT_ROUTE,
  'new-game-settings',
];
export const GAME_RUNNER_PREPARATION_ROUTE = [
  ...GAME_ROOT_ROUTE,
  'runner-preparation',
];
export const GAME_RUNNER_SOLICITATION_ROUTE = [
  ...GAME_ROOT_ROUTE,
  'runner-solicitation',
];
export const GAME_DETAILS_ROUTE = [...GAME_ROOT_ROUTE, 'details'];
export const GAME_ACTIVE_ROUTE = [...GAME_ROOT_ROUTE, 'active'];
export const GAME_EDIT_ROUTE = [...GAME_ROOT_ROUTE, 'edit'];
export const JACKPOT_WINNER_ROUTE = [...GAME_ROOT_ROUTE, 'jackpot-winner'];
export const GAME_CARD_ROUTE = [...GAME_ROOT_ROUTE, 'card'];
